import { api } from "aldoo-ra/API";
const kpiAPI = api("kpi");

export const ReportKPI = (event) => kpiAPI({ report_kpi: event });
export const ReadKPI = (query) => kpiAPI({ read_kpi: query });
export const ListKPIs = () => kpiAPI({ list_kpis: {} });
export const ListAppIds = () => kpiAPI({ list_app_ids: {} });
export const GetKPIDefinition = (kpi) => kpiAPI({ get_kpi_definition: { kpi } });
export const SaveDashboard = (dashboard) => kpiAPI({ save_dashboard: { dashboard } });
export const GetDashboards = () => kpiAPI({ get_dashboards: {} });
export const GetDashboard = (dashboardId) => kpiAPI({ get_dashboard: { dashboardId } });
export const DeleteDashboard = (dashboardId) => kpiAPI({ delete_dashboard: { dashboardId } });
